export let API_URL: string;

if (process.env.NODE_ENV === 'production') {
  API_URL = 'https://fuelproapi.azurewebsites.net';
} else {
  API_URL = 'https://localhost:7289';
}

export const getAuthHeader = () => {
  return {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('FuelProToken')}`,
    },
  };
};
export const getPDFAuthHeader = () => {
  return {
    headers: {
      Authorization: `Bearer ${localStorage.getItem('FuelProToken')}`,
    },
    responseType: 'blob' as 'text',
  };
};
